// extracted by mini-css-extract-plugin
export default {"global":"global__global--aX5Et"};